
// import React, { useState, useEffect } from 'react';
// import styles from '../../assets/scss/LoginComponent.module.scss';
// import Logo from '../../assets/images/cropLogo.png';
// import { useNavigate } from 'react-router-dom';
// import { userSingIn } from '../../../src/lib/authFunction/index';
// import { setToken } from '../../utils/auth.util';
// import { setUserInfo } from '../../utils/user.util';
// import { useForgotPasswordMutation, useSendOtpLoginMutation, useVerifyOtpLoginMutation } from '../../slices/admin/admin';
// import { toast } from 'react-toastify';
// import Lng from '../../Lng/Lng';

// const Login = () => {
//     const [activeTab, setActiveTab] = useState('email');
//     const [showOtp, setShowOtp] = useState(false);
//     const [mobile, setMobile] = useState('');
//     const [otp, setOtp] = useState(new Array(6).fill(''));
//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [error, setError] = useState('');
//     const [emailError, setEmailError] = useState('');
//     const [passwordError, setPasswordError] = useState('');
//     const [currentScreen, setCurrentScreen] = useState('login');
//     const [confirmPassword, setConfirmPassword] = useState('');
//     const [confirmPasswordError, setConfirmPasswordError] = useState('');

//     const navigate = useNavigate();

//     const [forgotPassword] = useForgotPasswordMutation();
//     const [sendOtpLogin, { isLoading: otpLoading }] = useSendOtpLoginMutation();
//     const [verifyOtpLogin, { isLoading: verifyLoading }] = useVerifyOtpLoginMutation();

//     // OTP resend timer
//     const [otpSent, setOtpSent] = useState(false);
//     const [resendTimer, setResendTimer] = useState(60);

//     // ✅ Helper to save login session
//     const saveLoginSession = (res) => {
//         if (res?.token) setToken(res.token);
//         setUserInfo(res?.user || res);
//     };

//     const handleMobileChange = (e) => {
//         const input = e.target.value;
//         if (!/^[0-9]*$/.test(input)) return;
//         if (input.length > 10) return;
//         if (input.length === 1 && !/^[6-9]$/.test(input)) return;
//         setMobile(input);
//         setError('');
//     };

//     const handleOtpChange = (element, index) => {
//         if (isNaN(element.value)) return;
//         const newOtp = [...otp];
//         newOtp[index] = element.value;
//         setOtp(newOtp);
//         if (element.nextSibling) element.nextSibling.focus();
//     };

//     const handleEmailLogin = async () => {
//         let hasError = false;
//         const passwordRegex = /^(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{10,}$/;

//         if (!email.trim()) { setEmailError('User ID is required'); hasError = true; } else setEmailError('');
//         if (!password.trim()) { setPasswordError('Password is required'); hasError = true; }
//         else if (!passwordRegex.test(password)) { setPasswordError('Password must be at least 10 characters and include one special character'); hasError = true; }
//         else setPasswordError('');

//         if (!hasError) {
//             try {
//                 const response = await userSingIn({ emailOrUsername: email, password });
//                 saveLoginSession(response?.data);
//                 toast.success('Logged in successfully');
//                 navigate('/dashboard');
//             } catch (err) {
//                 const msg = typeof err === 'string' ? err : 'Login failed. Please check your credentials.';
//                 setPasswordError(msg);
//             }
//         }
//     };

//     const handleSendOtp = async () => {
//         if (!mobile.trim()) { setError('Mobile number is required'); return; }
//         if (mobile.length !== 10) { setError('Mobile number must be exactly 10 digits'); return; }
//         if (!/^[6-9]\d{9}$/.test(mobile)) { setError('Invalid mobile number. First digit must be 6-9.'); return; }

//         try {
//             const res = await sendOtpLogin({ phone: mobile }).unwrap();
//             toast.success(res?.message || 'OTP sent successfully');
//             setShowOtp(true);
//             setError('');
//             setOtpSent(true);

//             // Start resend timer
//             setResendTimer(60);
//             const interval = setInterval(() => {
//                 setResendTimer(prev => {
//                     if (prev <= 1) { clearInterval(interval); setOtpSent(false); return 60; }
//                     return prev - 1;
//                 });
//             }, 1000);

//             console.log('OTP:', res?.otp); // remove in prod
//         } catch (err) {
//             const msg = err?.data?.message || err?.error || 'Failed to send OTP';
//             setError(msg);
//             toast.error(msg);
//         }
//     };

//     const handleLogin = async () => {
//         const enteredOtp = otp.join('');
//         if (enteredOtp.length !== 6 || !/^\d{6}$/.test(enteredOtp)) {
//             toast.error('Please enter valid 6 digit OTP');
//             return;
//         }
//         try {
//             const res = await verifyOtpLogin({ phone: mobile, otp: enteredOtp }).unwrap();
//             saveLoginSession(res);
//             toast.success(res?.message || 'Logged in successfully');
//             setTimeout(() => navigate('/dashboard'), 800);
//         } catch (err) {
//             const msg = err?.data?.message || err?.error || 'OTP verification failed';
//             toast.error(msg);
//         }
//     };

//     const handleSendResetLink = async () => {
//         if (!email.trim()) { setEmailError('Email ID is required'); return; }
//         try {
//             await forgotPassword({ email }).unwrap();
//             toast.success('Reset link sent to your email 🎉');
//             setCurrentScreen('login');
//             setActiveTab('email');
//             setEmail('');
//         } catch (err) {
//             const msg = err?.data?.message || 'Something went wrong';
//             toast.error(msg);
//         }
//     };

//     return (
//         <div className={styles.headmain}>
//             <div className={styles.loginContainer}>
//                 <div className={styles.logo}>
//                     <img src={Logo} alt="Logo" />
//                 </div>

//                 {currentScreen === 'login' && (
//                     <>
//                         <div className={styles.welcomeheader}>
//                             <h2 className={styles.heading}>Welcome <span className={styles.hand}>👋</span></h2>
//                             <div className={styles.lng}><Lng /></div>
//                         </div>

//                         <div className={styles.buttonGroup}>
//                             <button className={`${styles.btn} ${activeTab === 'email' ? styles.active : ''}`} onClick={() => { setActiveTab('email'); setError(''); setShowOtp(false); }}>
//                                 Login with User/Email ID
//                             </button>
//                             <button className={`${styles.btn} ${activeTab === 'otp' ? styles.active : ''}`} onClick={() => { setActiveTab('otp'); setError(''); }}>
//                                 Login with OTP
//                             </button>
//                         </div>

//                         {/* Email login */}
//                         {activeTab === 'email' && (
//                             <>
//                                 <input type="text" placeholder="User ID" className={styles.inputField} value={email} onChange={(e) => setEmail(e.target.value)} />
//                                 {emailError && <div className={styles.errorsMsg}>{emailError}</div>}
//                                 <input type="password" placeholder="Password" className={styles.inputField} value={password} onChange={(e) => setPassword(e.target.value)} />
//                                 {passwordError && <div className={styles.errorsMsg}>{passwordError}</div>}
//                                 <button className={styles.forgotPassword} onClick={() => setCurrentScreen('forgot')}>Forgot Password?</button>
//                                 <div className={styles.sendBtnContainer}><button className={styles.sendBtn} onClick={handleEmailLogin}>Login</button></div>
//                             </>
//                         )}

//                         {/* OTP login */}
//                         {activeTab === 'otp' && !showOtp && (
//                             <>
//                                 <input type="tel" placeholder="Enter Phone Number" className={styles.inputField} value={mobile} onChange={handleMobileChange} maxLength={10} />
//                                 {error && <div className={styles.errorsMsg}>{error}</div>}
//                                 <div className={styles.sendBtnContainer}>
//                                     <button className={styles.sendBtn} onClick={handleSendOtp} disabled={otpLoading || otpSent}>
//                                         {otpLoading ? 'Sending...' : otpSent ? `Resend in ${resendTimer}s` : 'Send OTP'}
//                                     </button>
//                                 </div>
//                             </>
//                         )}

//                         {/* {activeTab === 'otp' && showOtp && (
//               <>
//                 <div className={styles.otpInputs}>
//                   {otp.map((data, index) => (
//                     <input type="text" maxLength="1" key={index} value={data} onChange={(e) => handleOtpChange(e.target, index)} onFocus={(e) => e.target.select()} />
//                   ))}
//                 </div>
//                 <div className={styles.sendBtnContainer}>
//                   <button className={styles.sendBtn} onClick={handleLogin} disabled={verifyLoading}>
//                     {verifyLoading ? 'Verifying...' : 'Login'}
//                   </button>
//                 </div>
//               </>
//             )} */}
//                         {activeTab === 'otp' && showOtp && (
//                             <>
//                                 <div className={styles.otpInputs}>
//                                     {otp.map((data, index) => (
//                                         <input
//                                             type="text"
//                                             maxLength="1"
//                                             key={index}
//                                             value={data}
//                                             onChange={(e) => handleOtpChange(e.target, index)}
//                                             onFocus={(e) => e.target.select()}
//                                         />
//                                     ))}
//                                 </div>

//                                 {/* Resend OTP button */}
//                                 <div className={styles.resendOtpContainer}>
//                                     <button
//                                         className={styles.resendOtp}
//                                         onClick={handleSendOtp}
//                                         disabled={otpLoading || otpSent}
//                                     >
//                                         {otpSent ? `Resend in ${resendTimer}s` : 'Resend OTP'}
//                                     </button>
//                                 </div>

//                                 <div className={styles.sendBtnContainer}>
//                                     <button className={styles.sendBtn} onClick={handleLogin} disabled={verifyLoading}>
//                                         {verifyLoading ? 'Verifying...' : 'Login'}
//                                     </button>
//                                 </div>
//                             </>
//                         )}

//                     </>
//                 )}

//                 {currentScreen === 'forgot' && (
//                     <>
//                         <h2 className={styles.heading}>Forgot your password?</h2>
//                         <p>Your password will be sent by email.</p>
//                         <input type="text" placeholder="Enter Your Email ID" className={styles.inputField} value={email} onChange={(e) => setEmail(e.target.value)} />
//                         {emailError && <div className={styles.errorsMsg}>{emailError}</div>}
//                         <div className={styles.sendBtnContainer}><button className={styles.sendBtn} onClick={handleSendResetLink}>Next</button></div>
//                         <button className={styles.backToLogin} onClick={() => setCurrentScreen('login')}>Back to Login</button>
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Login;


import React, { useState, useEffect } from 'react';
import styles from '../../assets/scss/LoginComponent.module.scss';
import Logo from '../../assets/images/cropLogo.png';
import { useNavigate } from 'react-router-dom';
import { userSingIn } from '../../../src/lib/authFunction/index';
import { setToken } from '../../utils/auth.util';
import { setUserInfo } from '../../utils/user.util';
import { useForgotPasswordMutation, useResetPasswordSendOtpMutation, useResetPasswordUsingOtpMutation, useSendOtpLoginMutation, useVerifyOtpLoginMutation } from '../../slices/admin/admin';
import { toast } from 'react-toastify';
import Lng from '../../Lng/Lng';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = () => {
    const [activeTab, setActiveTab] = useState('email');
    const [showOtp, setShowOtp] = useState(false);
    const [mobile, setMobile] = useState('');
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [currentScreen, setCurrentScreen] = useState('login');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');

    const [forgotStep, setForgotStep] = useState('mobile'); // mobile | otp | password
    const [forgotMobile, setForgotMobile] = useState('');
    const [forgotOtp, setForgotOtp] = useState(new Array(6).fill(''));
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [forgotError, setForgotError] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showLoginPassword, setShowLoginPassword] = useState(false);



    const navigate = useNavigate();

    const [forgotPassword] = useForgotPasswordMutation();
    const [sendOtpLogin, { isLoading: otpLoading }] = useSendOtpLoginMutation();
    const [verifyOtpLogin, { isLoading: verifyLoading }] = useVerifyOtpLoginMutation();

    const [resetPasswordSendOtp] = useResetPasswordSendOtpMutation();
    const [resetPasswordUsingOtp] = useResetPasswordUsingOtpMutation();


    // OTP resend timer
    const [otpSent, setOtpSent] = useState(false);
    const [resendTimer, setResendTimer] = useState(60);

    // ✅ Helper to save login session
    const saveLoginSession = (res) => {
        if (res?.token) setToken(res.token);
        setUserInfo(res?.user || res);
    };

    const handleMobileChange = (e) => {
        const input = e.target.value;
        if (!/^[0-9]*$/.test(input)) return;
        if (input.length > 10) return;
        if (input.length === 1 && !/^[6-9]$/.test(input)) return;
        setMobile(input);
        setError('');
    };

    const resetForgotFlow = () => {
        setForgotMobile('');
        setForgotOtp(new Array(6).fill(''));
        setNewPassword('');
        setConfirmPassword('');
        setForgotError('');
        setForgotStep('mobile');
    };


    const validateMobile = (mobile) => {
        if (!/^[0-9]{10}$/.test(mobile)) return 'Mobile must be 10 digits';
        if (/^[1-5]/.test(mobile)) return 'Mobile number must start with 6-9';
        return '';
    };

    const handleResetSendOtp = async () => {
        const error = validateMobile(forgotMobile);
        if (error) {
            setForgotError(error);
            return;
        }

        try {
            const res = await resetPasswordSendOtp({ mobile: forgotMobile }).unwrap();
            toast.success(res.message);
            setForgotStep('otp');
        } catch (err) {
            toast.error(err?.data?.message || 'Failed to send OTP');
        }
    };


    const passwordRegex =
        /^(?=.*[A-Z])(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{10,}$/;


    const handleResetPassword = async () => {
        const otpValue = forgotOtp.join('');

        if (otpValue.length !== 6) {
            toast.error('Enter valid 6 digit OTP');
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        if (!passwordRegex.test(newPassword)) {
            toast.error(
                'Password must have 10 chars, 1 capital letter & 1 special character'
            );
            return;
        }

        try {
            const res = await resetPasswordUsingOtp({
                mobile: forgotMobile,
                otp: otpValue,
                newPassword,
                confirmPassword,
            }).unwrap();

            toast.success(res.message);
            resetForgotFlow();
            setCurrentScreen('login');
            setForgotStep('mobile');
        } catch (err) {
            toast.error(err?.data?.message || 'Password reset failed');
        }
    };

    const forgotOtpRefs = React.useRef([]);



    const handleOtpChange = (element, index) => {
        if (isNaN(element.value)) return;
        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);
        if (element.nextSibling) element.nextSibling.focus();
    };

    // const handleEmailLogin = async () => {
    //     let hasError = false;
    //     const passwordRegex = /^(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{10,}$/;

    //     if (!email.trim()) { setEmailError('User ID is required'); hasError = true; } else setEmailError('');
    //     if (!password.trim()) { setPasswordError('Password is required'); hasError = true; }
    //     else if (!passwordRegex.test(password)) { setPasswordError('Password must be at least 10 characters and include one special character'); hasError = true; }
    //     else setPasswordError('');

    //     if (!hasError) {
    //         try {
    //             const response = await userSingIn({ emailOrUsername: email, password });
    //             saveLoginSession(response?.data);
    //             toast.success('Logged in successfully');
    //             navigate('/dashboard');
    //         } catch (err) {
    //             const msg = typeof err === 'string' ? err : 'Login failed. Please check your credentials.';
    //             setPasswordError(msg);
    //         }
    //     }
    // };

    const handleEmailLogin = async () => {
        let hasError = false;
        const passwordRegex = /^(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{10,}$/;

        if (!email.trim()) {
            setEmailError('User ID is required');
            hasError = true;
        } else {
            setEmailError('');
        }

        if (!password.trim()) {
            setPasswordError('Password is required');
            hasError = true;
        } else if (!passwordRegex.test(password)) {
            setPasswordError(
                'Password must be at least 10 characters and include one special character'
            );
            hasError = true;
        } else {
            setPasswordError('');
        }

        if (!hasError) {
            try {
                const response = await userSingIn({
                    emailOrUsername: email,
                    password,
                });

                saveLoginSession(response?.data);
                toast.success('Logged in successfully');
                navigate('/dashboard');

            } catch (err) {
                const msg =
                    err?.response?.data?.message ||
                    err?.data?.message ||
                    err?.message ||
                    'Login failed. Please check your credentials.';

                setPasswordError(msg);
            }
        }
    };


    const handleSendOtp = async () => {
        if (!mobile.trim()) { setError('Mobile number is required'); return; }
        if (mobile.length !== 10) { setError('Mobile number must be exactly 10 digits'); return; }
        if (!/^[6-9]\d{9}$/.test(mobile)) { setError('Invalid mobile number. First digit must be 6-9.'); return; }

        try {
            const res = await sendOtpLogin({ phone: mobile }).unwrap();
            toast.success(res?.message || 'OTP sent successfully');
            setShowOtp(true);
            setError('');
            setOtpSent(true);

            // Start resend timer
            setResendTimer(60);
            const interval = setInterval(() => {
                setResendTimer(prev => {
                    if (prev <= 1) { clearInterval(interval); setOtpSent(false); return 60; }
                    return prev - 1;
                });
            }, 1000);

            console.log('OTP:', res?.otp); // remove in prod
        } catch (err) {
            const msg = err?.data?.message || err?.error || 'Failed to send OTP';
            setError(msg);
            toast.error(msg);
        }
    };

    const handleLogin = async () => {
        const enteredOtp = otp.join('');
        if (enteredOtp.length !== 6 || !/^\d{6}$/.test(enteredOtp)) {
            toast.error('Please enter valid 6 digit OTP');
            return;
        }
        try {
            const res = await verifyOtpLogin({ phone: mobile, otp: enteredOtp }).unwrap();
            saveLoginSession(res);
            toast.success(res?.message || 'Logged in successfully');
            setTimeout(() => navigate('/dashboard'), 800);
        } catch (err) {
            const msg = err?.data?.message || err?.error || 'OTP verification failed';
            toast.error(msg);
        }
    };

    const handleSendResetLink = async () => {
        if (!email.trim()) { setEmailError('Email ID is required'); return; }
        try {
            await forgotPassword({ email }).unwrap();
            toast.success('Reset link sent to your email 🎉');
            setCurrentScreen('login');
            setActiveTab('email');
            setEmail('');
        } catch (err) {
            const msg = err?.data?.message || 'Something went wrong';
            toast.error(msg);
        }
    };

    return (
        <div className={styles.headmain}>
            <div className={styles.loginContainer}>
                <div className={styles.innerBorderBox}>
                    <div className={styles.logo}>
                        <img src={Logo} alt="Logo" />
                    </div>

                    {currentScreen === 'login' && (
                        <>
                            <div className={styles.welcomeheader}>
                                <h2 className={styles.heading}>Welcome <span className={styles.hand}>👋</span></h2>
                                <div className={styles.lng}><Lng /></div>
                            </div>

                            <div className={styles.buttonGroup}>
                                <button className={`${styles.btn} ${activeTab === 'email' ? styles.active : ''}`} onClick={() => { setActiveTab('email'); setError(''); setShowOtp(false); }}>
                                    User/Email ID Login
                                </button>
                                <button className={`${styles.btn} ${activeTab === 'otp' ? styles.active : ''}`} onClick={() => { setActiveTab('otp'); setError(''); }}>
                                    OTP Login
                                </button>
                            </div>

                            {/* Email login */}
                            {activeTab === 'email' && (
                                <>
                                    <input type="text" placeholder="User ID" className={styles.inputField} value={email} onChange={(e) => setEmail(e.target.value)} />
                                    {emailError && <div className={styles.errorsMsg}>{emailError}</div>}
                                    {/* <input type="password" placeholder="Password" className={styles.inputField} value={password} onChange={(e) => setPassword(e.target.value)} /> */}
                                    <div className={styles.passwordWrapper}>
                                        <input
                                            type={showLoginPassword ? "text" : "password"}
                                            placeholder="Password"
                                            className={styles.inputField}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />

                                        <span
                                            className={styles.eyeIcon}
                                            onClick={() => setShowLoginPassword(prev => !prev)}
                                        >
                                            {showLoginPassword ? <FaEye /> : <FaEyeSlash />}
                                        </span>
                                    </div>

                                    {passwordError && <div className={styles.errorsMsg}>{passwordError}</div>}


                                    {passwordError && <div className={styles.errorsMsg}>{passwordError}</div>}
                                    <button className={styles.forgotPassword} onClick={() => setCurrentScreen('forgot')}>Forgot Password?</button>
                                    <div className={styles.sendBtnContainer}><button className={styles.sendBtn} onClick={handleEmailLogin}>Login</button></div>
                                </>
                            )}

                            {/* OTP login */}
                            {activeTab === 'otp' && !showOtp && (
                                <>
                                    <input type="tel" placeholder="Enter Phone Number" className={styles.inputField} value={mobile} onChange={handleMobileChange} maxLength={10} />
                                    {error && <div className={styles.errorsMsg}>{error}</div>}
                                    <div className={styles.sendBtnContainer}>
                                        <button className={styles.sendBtn} onClick={handleSendOtp} disabled={otpLoading || otpSent}>
                                            {otpLoading ? 'Sending...' : otpSent ? `Resend in ${resendTimer}s` : 'Send OTP'}
                                        </button>
                                    </div>
                                </>
                            )}

                            {/* {activeTab === 'otp' && showOtp && (
                  <>
                    <div className={styles.otpInputs}>
                      {otp.map((data, index) => (
                        <input type="text" maxLength="1" key={index} value={data} onChange={(e) => handleOtpChange(e.target, index)} onFocus={(e) => e.target.select()} />
                      ))}
                    </div>
                    <div className={styles.sendBtnContainer}>
                      <button className={styles.sendBtn} onClick={handleLogin} disabled={verifyLoading}>
                        {verifyLoading ? 'Verifying...' : 'Login'}
                      </button>
                    </div>
                  </>
                )} */}
                            {activeTab === 'otp' && showOtp && (
                                <>
                                    <div className={styles.otpInputs}>
                                        {otp.map((data, index) => (
                                            <input
                                                type="text"
                                                maxLength="1"
                                                key={index}
                                                value={data}
                                                onChange={(e) => handleOtpChange(e.target, index)}
                                                onFocus={(e) => e.target.select()}
                                            />
                                        ))}
                                    </div>

                                    {/* Resend OTP button */}
                                    <div className={styles.resendOtpContainer}>
                                        <button
                                            className={styles.resendOtp}
                                            onClick={handleSendOtp}
                                            disabled={otpLoading || otpSent}
                                        >
                                            {otpSent ? `Resend in ${resendTimer}s` : 'Resend OTP'}
                                        </button>
                                    </div>

                                    <div className={styles.sendBtnContainer}>
                                        <button className={styles.sendBtn} onClick={handleLogin} disabled={verifyLoading}>
                                            {verifyLoading ? 'Verifying...' : 'Login'}
                                        </button>
                                    </div>
                                </>
                            )}

                        </>
                    )}

                    {/* {currentScreen === 'forgot' && (
                        <>
                            <h2 className={styles.heading}>Forgot your password?</h2>
                            <p>Your password will be sent by email.</p>
                            <input type="text" placeholder="Enter Your Email ID" className={styles.inputField} value={email} onChange={(e) => setEmail(e.target.value)} />
                            {emailError && <div className={styles.errorsMsg}>{emailError}</div>}
                            <div className={styles.sendBtnContainer}><button className={styles.sendBtn} onClick={handleSendResetLink}>Next</button></div>
                            <button className={styles.backToLogin} onClick={() => setCurrentScreen('login')}>Back to Login</button>
                        </>
                    )} */}

                    {currentScreen === 'forgot' && forgotStep === 'mobile' && (
                        <>
                            <h2 className={styles.heading}>Forgot your password?</h2>
                            <input
                                type="tel"
                                placeholder="Enter Mobile Number"
                                className={styles.inputField}
                                value={forgotMobile}
                                onChange={(e) => setForgotMobile(e.target.value)}
                                maxLength={10}
                            />
                            {forgotError && <div className={styles.errorsMsg}>{forgotError}</div>}
                            <div className={styles.sendBtnContainer}>
                                <button className={styles.sendBtn} onClick={handleResetSendOtp}>
                                    Send OTP
                                </button>
                            </div>
                            <button
                                className={styles.backToLogin}
                                onClick={() => {
                                    resetForgotFlow();
                                    setCurrentScreen('login');
                                }}
                            >
                                Back to Login
                            </button>
                        </>
                    )}

                    {currentScreen === 'forgot' && forgotStep === 'otp' && (
                        <>
                            <h2 className={styles.heading}>Enter valid OTP</h2>

                            <div className={styles.otpInputs}>
                                {forgotOtp.map((v, i) => (
                                    <input
                                        key={i}
                                        type="text"
                                        maxLength="1"
                                        value={v}
                                        ref={(el) => (forgotOtpRefs.current[i] = el)}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (!/^[0-9]?$/.test(val)) return;

                                            const copy = [...forgotOtp];
                                            copy[i] = val;
                                            setForgotOtp(copy);

                                            // 👉 Move to next input
                                            if (val && i < 5) {
                                                forgotOtpRefs.current[i + 1]?.focus();
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            // 👉 Backspace logic
                                            if (e.key === 'Backspace' && !forgotOtp[i] && i > 0) {
                                                forgotOtpRefs.current[i - 1]?.focus();
                                            }
                                        }}
                                    />
                                ))}
                            </div>

                            <div className={styles.sendBtnContainer}>
                                <button className={styles.sendBtn} onClick={() => setForgotStep('password')}>
                                    Verify OTP
                                </button>
                            </div>
                            <button
                                className={styles.backToLogin}
                                onClick={() => {
                                    setForgotStep('mobile');
                                    setForgotOtp(new Array(6).fill(''));
                                }}
                            >
                                Back to Mob Login
                            </button>



                        </>
                    )}
                    {currentScreen === 'forgot' && forgotStep === 'password' && (

                        <>
                            <h2 className={styles.heading}>Enter your New Password</h2>
                            {/* <input
                                type="password"
                                placeholder="New Password"
                                className={styles.inputField}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            /> */}
                            <div className={styles.passwordWrapper}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="New Password"
                                    className={styles.inputField}
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />

                                <span
                                    className={styles.eyeIcon}
                                    onClick={() => setShowPassword(prev => !prev)}
                                >
                                    {showPassword ? < FaEye /> : <FaEyeSlash />}
                                </span>
                            </div>


                            {/* <input
                                type="password"
                                placeholder="Confirm Password"
                                className={styles.inputField}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            /> */}
                            <div className={styles.passwordWrapper}>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    className={styles.inputField}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />

                                <span
                                    className={styles.eyeIcon}
                                    onClick={() => setShowConfirmPassword(prev => !prev)}
                                >
                                    {showConfirmPassword ? < FaEye /> : <FaEyeSlash />}
                                </span>
                            </div>


                            <div className={styles.sendBtnContainer}>
                                <button className={styles.sendBtn} onClick={handleResetPassword}>
                                    Reset Password
                                </button>
                            </div>

                            <button
                                className={styles.backToLogin}
                                onClick={() => {
                                    setForgotStep('otp');
                                }}
                            >
                                Back to OTP
                            </button>


                        </>
                    )}

                </div>
            </div>
        </div>
    );
};

export default Login;